import React, { Component } from 'react';

class NoRecords extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="card text-center">
                <span>No {this.props.type ? this.props.type : 'records'} to display!</span>
            </div>
        );
    }
}

export default NoRecords;


// WEBPACK FOOTER //
// ./app/util/noRecords.js